export default __webpack_public_path__ + "static/dawn-ae12451e49ab6e9910eaf4d4abe29fd4.webp";